import { get } from 'lodash';
import * as types from '../constants/action-types';
import { ApiCallState } from '../constants/other';
const loadingInitialState = {};
export const loadingReducer = (state = loadingInitialState, action) => {
    const { type } = action;
    if (type === types.RESET)
        return loadingInitialState;
    const matches = new RegExp(`(.*)_(${ApiCallState.request}|${ApiCallState.success}|${ApiCallState.error})`).exec(action.type);
    // not a *_REQUEST/*_SUCCESS/*_ERROR actions, so we ignore them
    if (!matches)
        return state;
    const [, requestName, requestState] = matches;
    const stateProp = get(action, 'payload.requestId', requestName);
    return {
        ...state,
        [stateProp]: requestState === ApiCallState.request,
    };
};
export default loadingReducer;
